<section class="nw_service_th" *ngIf="!loader && businessListData.length > 0">
    <div class="service_se" style="display: flex;justify-content: space-between;">
        <div class="heading_sert">
            <h3> All customers </h3>
        </div>
        <div class="create_btn_sd">
            <button mat-icon-button color="primary" (click)="addcustomer()"  >
                <mat-icon>add</mat-icon> 
            </button>
        </div>
    </div>
    <div class="chip_services_list">
        <mat-chip-listbox class="example-chip">
            <mat-chip (click)="selectBusiness(i)" *ngFor="let item of businessListData; let i =index" [ngClass]="{'Graceful-box-active': item.isSelected == 1}" >{{item.name}}</mat-chip>
       </mat-chip-listbox>
    </div>
    <div class="service_create_sd" style="
    margin-bottom: 20px;">
    <div class="row" >
        <div class="col-sm-10">
           <div class="serv_heading">
            <h3>Customers of {{selectedBusiness.name}}</h3>
            <p>{{selectedBusiness.address_line}}</p>

        </div>
      </div>
      <div class="col-sm-2">
      </div>
    </div>
     <div class="search-bar-custom">
        <mat-form-field appearance="outline">
            <mat-label>Search</mat-label>
            <input [formControl]="searchString" (keyup)="searchServiceData()" matInput placeholder="Search for customers">
            <button
          mat-button
          *ngIf="!searchString.value"
          matSuffix
          aria-label="Clear"
        >
          <mat-icon>search</mat-icon>
        </button>
        <button
        mat-button
        *ngIf="searchString.value"
        matSuffix
        aria-label="Clear"
        (click)="reset()"
      >
        <mat-icon>close</mat-icon>
      </button>
        </mat-form-field>
    </div>
    </div>

    <div class="service_card_sedf" *ngIf="customersData.length > 0">
        <div class="row">
            <div class="col-sm-6" *ngFor="let item of customersData">
                <div class="serv_sect">
                  <mat-card >
    <div class="package-card" >
      <div class="package-header">
        <div class="profile-container">
          <div class="booking-initial" *ngIf="!item.image_thumb_url || item.image_thumb_url == 'null'">{{item.name.slice(0,1).toUpperCase()}}</div>
          <div class="profile-image booking-initial-img" *ngIf="item.image_thumb_url && item.image_thumb_url != 'null'">
            <!-- <span class="initials" *ngIf="!item.image_thumb_url || item.image_thumb_url == 'null'">N</span> -->
            <img class="img-fluid rounded-circle" [src]="item.image_thumb_url" alt=""  onerror="this.src='../../../../assets/images/user-avatar.svg'">
          </div>

          <div class="profile_texc">
          <h2 class="package-title">{{item.name}}</h2>
          <p class="package-detail">{{item.cust_phone}}{{item.gender1 && item.gender1 != '---' ? ', ' + item.gender1 : ''}}</p>
        </div>

        </div>
    
        

        <button mat-icon-button [matMenuTriggerFor]="menu" class="package-options" >
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="viewdetailsopen(item)">
            <mat-icon class="material-icons-outlined">info</mat-icon>
            <span>View details</span>
          </button>
          <button mat-menu-item (click)="createInvoice(item)" *ngIf="isAccessForEmployeeInvoice">
            <mat-icon class="material-icons-outlined">playlist_add</mat-icon>
            <span>Create invoice</span>
          </button>
          <!-- <button mat-menu-item (click)="openAllBookings(item)">
            <mat-icon>list</mat-icon>
            <span>{{ 'customers.op1' | translate }}</span>
          </button> -->
          <!-- <button mat-menu-item (click)="openAllPayments(item)">
            <mat-icon class="material-icons-outlined">receipt</mat-icon>
            <span>See all payments</span>
          </button> -->
          <button mat-menu-item (click)="openDueBookings(item)">
            <mat-icon class="material-icons-outlined">pending_actions</mat-icon>
            <span>See due bills/invoices</span>
          </button>
       
          <button mat-menu-item (click)="openPaymentIntimation(item)" *ngIf="item.total_due > 0 && selectedBusiness.is_owner == 1">
            <mat-icon class="material-icons-outlined">share</mat-icon>
            <span>{{ 'customers.op3' | translate }}</span>
          </button>
          <!-- <button mat-menu-item (click)="deleteCustomer(item)" >
            <mat-icon class="material-icons-outlined">delete</mat-icon>
            <span>Delete Customer</span>
          </button> -->
        </mat-menu>
        
      </div>
      
    
      <p class="package-highlight"><span class="deo_heading">Due:</span>  <span class="cureent_ht">{{item.currency_symbol}}{{item.total_due.toFixed(2)}}</span></p>
      <p class="package-date"><span class="deo_heading">Last booking: </span> <span class="cureent_ht">{{item.l_booking_date}}</span></p>
    </div>
  </mat-card>
    </div>
    </div>

    
    </div>
    </div>


        <!-- Placeholder design html start -->
        <div class="placeholder_started" *ngIf="!loader && customersData.length == 0">
      <div class="row">
        <div class="col-sm-4" *ngIf="selectedValue == '0'">
          <div class="dashboard_new">
            <mat-card>
                <div class="upload_sectio">
               <div class="icm_img">
                  <img src="./assets/images/customer-1.jpg">
               </div>
               <mat-card-title>No customer to show.</mat-card-title>
               <mat-card-content>Creating booking and invoice adds customers automatically to your business. You can add customers manually too.
              </mat-card-content>
               <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary" (click)="addcustomer()">
                     <mat-icon>add</mat-icon>
                     Add customer
                  </button>
               </div>
               </div>
            </mat-card>
         </div>
        </div>
        <div class="col-sm-4" *ngIf="selectedValue == '1'">
          <div class="dashboard_new">
            <mat-card>
                <div class="upload_sectio">
               <div class="icm_img">
                  <img src="./assets/images/customer-1.jpg">
               </div>
               <mat-card-title>No customer with dues.</mat-card-title>
               <mat-card-content>The customers with unpaid invoices and dues in payments, will show here. Apart from the due data and other information, you can send them payment intimation too.
              </mat-card-content>
               <!-- <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary">
                     <mat-icon>add</mat-icon>
                     Add customer
                  </button>
               </div> -->
               </div>
            </mat-card>
         </div>
        </div>
        <div class="col-sm-4" *ngIf="selectedValue == '2'">
          <div class="dashboard_new">
            <mat-card>
                <div class="upload_sectio">
               <div class="icm_img">
                  <img src="./assets/images/customer-1.jpg">
               </div>
               <mat-card-title>No long absent customer yet.</mat-card-title>
               <mat-card-content>The customers who haven't visited the business for long, will appear here. You can get their details, contact them, send them personalized message with offers.
              </mat-card-content>
               <!-- <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary">
                     <mat-icon>add</mat-icon>
                     Add customer
                  </button>
               </div> -->
               </div>
            </mat-card>
         </div>
        </div>
        <div class="col-sm-4">
          <div class="dashboard_new">
            <mat-card>
                <div class="upload_sectio">
               <div class="icm_img">
                  <img src="./assets/images/helpsupport.png">
               </div>
               <mat-card-title>Facing any issue?</mat-card-title>
               <mat-card-content>For any difficulties in creating a new customer or if there's any issue with customer data, contact the support team.
              </mat-card-content>
               <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary"  (click)="opencontact()">
                     <mat-icon>support_agent</mat-icon>
                     Contact support 
                  </button>
               </div>
               </div>
            </mat-card>
         </div>
        </div>
      </div>
</div> 
          <!-- Placeholder design html start -->

</section>

<section class="nw_service_th" *ngIf="!loader && businessListData.length == 0">
    <div class="">
        <div class="heading_sert">
            <h3>All customers</h3>
        </div>
    </div>

       <!-- Placeholder design html start -->
       <div class="placeholder_started__business">
        <div class="row">
          <div class="col-sm-4" *ngIf="!isEmployeeAndHasBusinessButDoesNotHaveAccess">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/business-create.png" style="width: 110px;">
                 </div>
                 <mat-card-title>No business added yet.</mat-card-title>
                 <mat-card-content>To add your customers you need to create a business first. Customers will be added under that business.
                </mat-card-content>
                 <div class="create_btnyh">
                    <button mat-flat-button color="primary" (click)="selectcountry()">
                        <mat-icon>add</mat-icon> 
                        Create a business
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
         <div class="col-sm-4" *ngIf="isEmployeeAndHasBusinessButDoesNotHaveAccess">
                <div class="dashboard_new" >
                  <mat-card appearance="outlined" style="">
                      <div class="upload_sectio">
                     <div class="icm_img">
                        <img src="./assets/images/business-create.png" style="width: 110px;">
                     </div>
                     <mat-card-title>Access denied.</mat-card-title>
                     <mat-card-content> Business owner with valid premium business subscription or an active employee with permission can access this section. Check current plans. Recharge pack if expired.
                    </mat-card-content>
                     
                     </div>
                  </mat-card>
               </div>
              </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Having any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in adding customers or if there's any issue while adding customers, contact our support team.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="opencontact()">
                       <mat-icon>support_agent</mat-icon>
                       Contact support
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
    
      </div>
      <!-- Placeholder design html start -->
    
      
</section>